import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_ADMIN_SCHEDULE_VARIANCE_API } from "./apiRoutes";

interface Props {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getScheduleVariance = async (projectId: string): Promise<any> => {
  return await axiosAuth.get(`${DASHBOARD_ADMIN_SCHEDULE_VARIANCE_API(projectId)}`);
};

const useGetScheduleVariance = ({ projectId, queryParams }: Props): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-pm-schedule-variance", projectId],
    queryFn: () => getScheduleVariance(projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
    ...queryParams,
  });
};

export default useGetScheduleVariance;
